/** Ошибка API с HTTP-статусом для единых retry/error-контрактов. */
export class ExperienceApiError extends Error {
  public readonly status: number | undefined;
  public readonly isNetworkError: boolean;

  /** Создаёт ошибку с сохранённым HTTP-статусом ответа. */
  public constructor(message: string, status?: number, isNetworkError = false) {
    super(message);
    this.name = 'ExperienceApiError';
    this.status = status;
    this.isNetworkError = isNetworkError;
  }
}

/** Извлекает HTTP-статус из неизвестной ошибки generated client. */
export const getErrorStatus = (error: unknown): number | undefined => {
  if (error instanceof ExperienceApiError) {
    return error.status;
  }

  if (typeof error !== 'object' || error === null || !('status' in error)) {
    return undefined;
  }

  const status = error.status;

  return typeof status === 'number' ? status : undefined;
};

/** Определяет AbortError, который не должен отображаться пользователю и повторяться. */
export const isAbortError = (error: unknown): boolean => {
  if (error instanceof DOMException) {
    return error.name === 'AbortError';
  }

  if (typeof error !== 'object' || error === null || !('name' in error)) {
    return false;
  }

  return error.name === 'AbortError';
};

/** Нормализует generated client error в typed ExperienceApiError без потери статуса. */
export const normalizeApiError = (error: unknown): ExperienceApiError => {
  if (error instanceof ExperienceApiError) {
    return error;
  }

  const status = getErrorStatus(error);
  const message = error instanceof Error ? error.message : 'Ошибка API региона';

  return new ExperienceApiError(message, status, status === undefined);
};

/** Решает, нужен ли повтор: только 408/429, сеть и 5xx, максимум три повтора. */
export const shouldRetryQuery = (failureCount: number, error: unknown): boolean => {
  if (failureCount >= 3 || isAbortError(error)) {
    return false;
  }

  const status = getErrorStatus(error);

  if (status === undefined && error instanceof ExperienceApiError) {
    return error.isNetworkError;
  }

  return status === undefined || status === 408 || status === 429 || status >= 500;
};
